import { handleActions } from 'redux-actions';

import { generateFormattedPois } from '../../utilities/format_pois_util';
import assignDeep from '../../utilities/assign-deep';

import {
  FETCH_JOURNAL,
  SET_JOURNAL,
  RESET_JOURNAL,
} from '../../actionTypes/journal';

import {
  FETCH_JOURNAL_LIKE_SUCCESS,
  FETCH_JOURNAL_LIKE_FAIL,
  FETCH_JOURNAL_LIKE_LOADING,
  COPY_TRIP_SUCCESS,
  USER_LOG_OUT,
} from '../../actions/action_types';

const INITIAL_STATE = {
  data: null,
  error: null,
  asideList: [],
  loading: false,
};

// TODO: reducer 不該存在多種寫法 待之後合併回去
export default handleActions(
  {
    [FETCH_JOURNAL.SUCCESS](state, { payload }) {
      const { dayCount, startTime, pois } = payload.results;
      const array = [];
      pois.forEach(element => {
        const object = { ...element.trip, journal: element.journal };
        array.push(object);
      });
      const itinerary = { dayCount, startTime, pois: array };
      const journal = {
        ...payload.results,
        formattedPois: generateFormattedPois(itinerary),
      };
      return { ...state, data: journal, error: null, loading: false };
    },
    [FETCH_JOURNAL.FAIL](state, { payload }) {
      return { ...state, error: payload };
    },
    [SET_JOURNAL](state, { payload }) {
      return { ...assignDeep(state, payload) };
    },
    [RESET_JOURNAL](state) {
      return {
        data: null,
        error: null,
        asideList: [],
        loading: true,
      };
    },
    [FETCH_JOURNAL_LIKE_SUCCESS](state, { payload }) {
      const { like_counts, is_like } = payload;
      return {
        ...state,
        data: {
          ...state.data,
          journal: {
            ...state.data.journal,
            like_counts,
            is_like,
          },
          common: {
            ...state.data.common,
            like_counts,
            is_like,
          },
        },
        error: null,
      };
    },
    // todo: waiting toast component...
    [FETCH_JOURNAL_LIKE_FAIL](state) {
      return { ...state };
    },
    // todo: waiting toast component...
    [FETCH_JOURNAL_LIKE_LOADING](state) {
      return { ...state };
    },
    [COPY_TRIP_SUCCESS](state) {
      const copyCounts = state.data.journal.copy_counts + 1;
      return {
        ...state,
        data: {
          ...state.data,
          journal: {
            ...state.data.journal,
            copy_counts: copyCounts,
          },
          common: {
            ...state.data.common,
            copy_counts: copyCounts,
          },
        },
        error: null,
      };
    },
    [USER_LOG_OUT](state) {
      return {
        data: null,
        error: null,
        asideList: [],
        loading: true,
      };
    },
  },
  INITIAL_STATE,
);
